import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";

import Aux from "../Aux";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import FormWrapper from "../../components/FormWrapper";
import FlexWrapper from "../../components/FlexWrapper";
import EditSideColumn from "./components/EditSideColumn";

import {
  getUser,
  removeUser,
  getUserGroups,
  editUser
} from "../../store/AdminUsers/services";

import { validateUser } from "../../utils/UserPermissions";

import Form from "./Form";

class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["EDIT_USERS", "ALL"]
    };
  }

  submit = values => {
    const id = this.props.match.params.id;
    this.props.dispatch(editUser(id, values));
  };

  remove = () => {
    const id = [this.props.match.params.id];
    if (this.props.user.is_admin) {
      return alert("You cannot remove an admin account.");
    }
    const confirm = window.confirm(
      "Are you sure you want to remove " + this.props.user.first_name + "?"
    );
    if (confirm) {
      this.props.dispatch(removeUser(id));
    }
  };

  componentDidMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
    this.props.dispatch(getUser(this.props.match.params.id));
    this.props.dispatch(getUserGroups());
  }

  render() {
    let { loading, user, success } = this.props;
    if (loading) {
      return <Loading />;
    }
    if (success) {
      // Redirect when entry created
      return <Redirect to="/admin-users" />;
    }
    return (
      <Aux>
        <PageHeader title={"Edit " + user.first_name + " " + user.last_name} />
        <FlexWrapper>
          <FormWrapper>
            <Scrollbars>
              <Form
                onSubmit={this.submit}
                mode="edit"
                userGroups={this.props.groups}
                initialValues={this.props.user}
              />
            </Scrollbars>
          </FormWrapper>
          <EditSideColumn
            submit={this.submit}
            permissions={this.props.permissions}
            mode="edit"
            remove={this.remove}
          />
        </FlexWrapper>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    user: store.adminUser.user,
    success: store.adminUser.success,
    permissions: store.auth.permissions,
    error: store.adminUser.error,
    groups: store.adminUser.groups,
    groupsLoading: store.adminUser.groupsLoading,
    loading: store.adminUser.isLoading
  };
}

export default withRouter(connect(mapStateToProps)(Edit));



// WEBPACK FOOTER //
// ./src/system/containers/AdminUsers/Edit.jsx